import { ThunkAction } from 'redux-thunk'
import { State, ReduxAction } from '../../reducers/reducerType'
import { closeGigEndConfirmationModal } from '../ui/uiActions'
import get from 'lodash/get'
import audit, { addEntry } from '../../../lib/audit'
import apiGateway from '../../../services/apiGateway'
import { createAction } from '@reduxjs/toolkit'
import { GigTypes } from './gigTypes'
import { closeGigStartConfirmationModal } from '../ui/uiActions'
import * as actionTypes from '../../constants/actionTypes'
import docUpdateAndLog from '../../../lib/docUpdateAndLog'

export const setEndingLiveSuccess = createAction(GigTypes.SET_ENDING_LIVE_SUCCESS)
export const terminateGig = createAction(GigTypes.TERMINATE_GIG)
export const setToLiveEnded = () => async (dispatch, getState) => {

  const { docs: { uiDoc }, user } = getState()
  const name = `${get(user, 'data.firstName')} ${get(user, 'data.lastName')}` || 'Name not set'

  await docUpdateAndLog(uiDoc, { goingLive: false, endingLive: true }, 'uiDoc')
  /** SET_ENDING_LIVE will be dispatched from UI doc events when the above has updated */

  try {

    addEntry('PresenterService', 'GigEnd', `${name} is ending the gig`)
    await apiGateway.endLive(getState().config.roomname)
    addEntry('PresenterService', 'GigEndSuccess', `${name}'s call to end the gig was successful`)
    dispatch(setEndingLiveSuccess())

  }
  catch (e) {

    addEntry('PresenterService', 'GigEndError', `${name}'s call to end the gig failed`)

    await docUpdateAndLog(uiDoc, { endingLive: false }, 'uiDoc', 'GigEndError')

  }

  dispatch(closeGigEndConfirmationModal())

}

export const actionTerminateGig = (): ThunkAction<void, State, unknown, ReduxAction> => async (dispatch, getState) => {

  dispatch(terminateGig())

  try {

    setToLiveEnded()(dispatch, getState)

  }
  catch (e) {

    console.log(e)

  }

}

export const setLocalBridge = (value) => ({ type: actionTypes.SET_LOCAL_BRIDGE, payload: value })

export const setLiveTime = updatedDateTime => async (dispatch, getState) => {

  const date = new Date(updatedDateTime)
  const { docs: { uiDoc } } = getState()
  const payload = typeof date === 'object' ? date.toISOString() : null
  const curLiveDateTime = get(uiDoc.data, 'liveDateTime', '')

  if (curLiveDateTime !== payload) {

    await docUpdateAndLog(uiDoc, { liveDateTime: payload }, 'uiDoc')

  }

  return dispatch({ type: GigTypes.SET_LIVE_TIME, payload })

}
export const setIsGoingLive = () => ({ type: GigTypes.SET_GOING_LIVE })
export const unsetIsGoingLive = () => ({ type: GigTypes.UNSET_GOING_LIVE })
export const setToLive = () => async (dispatch, getState) => {

  const { docs: { uiDoc }, user } = getState()
  const name = `${get(user, 'data.firstName')} ${get(user, 'data.lastName')}` || 'Name not set'

  await docUpdateAndLog(uiDoc, { goingLive: true, endingLive: false }, 'uiDoc')
  /** SET_GOING_LIVE will be dispatched from the UI doc events when the above has updated */

  try {

    addEntry('PresenterService', 'GigStart', `${name} is starting the gig`)
    await apiGateway.goLive(getState().config.roomname)
    addEntry('PresenterService', 'GigStartSuccess', `${name}'s call to start the gig was successful`)

    // TODO no reducer is listening to this ...
    dispatch({ type: GigTypes.SET_GOING_LIVE_SUCCESS })

  }
  catch (e) {

    addEntry('PresenterService', 'GigStartError', `${name}'s call to start the gig failed`)
    uiDoc.update({ goingLive: false, endingLive: false })

  }

  dispatch(closeGigStartConfirmationModal())

}
export const setToLiveEndedConfirmed = () => ({ type: GigTypes.ENDING_LIVE_CONFIRMED })
export const setIsEndingLive = () => ({ type: GigTypes.SET_ENDING_LIVE })
export const unsetIsEndingLive = () => ({ type: GigTypes.UNSET_ENDING_LIVE })
export const extendGigTermination = () => async (dispatch, getState) => {

  const { docs: { uiDoc }, room: { gigTerminationTime: curTerminationTime }, user } = getState()
  const name = `${get(user, 'data.firstName', '')} ${get(user, 'data.lastName', '')}`.trim()

  const gigTerminationTime = new Date(curTerminationTime)
  gigTerminationTime.setMinutes(gigTerminationTime.getMinutes() + 15)

  dispatch({ type: GigTypes.EXTEND_GIG_TERMINATION })

  audit.addEntry('PresenterService', 'GigExtend', `${name || user.BTID} is extending the gig`)

  try {

    await docUpdateAndLog(uiDoc, { gigTerminationTime: gigTerminationTime.toISOString() }, 'uiDoc')
    audit.addEntry('PresenterService', 'GigExtendSuccess', `${name || user.BTID}'s call to extend the gig succeeded`)

  }
  catch (e) {

    audit.addEntry('PresenterService', 'GigExtendError', `${name || user.BTID}'s call to extend the gig failed`)

  }

}
export const extendGigTerminationSuccess = (gigTerminationTime: string) => async (dispatch, getState) => {

  const { room: { gigTerminationTime: curTerminationTime } } = getState()

  dispatch({ type: GigTypes.EXTEND_GIG_TERMINATION_SUCCESS, payload: new Date(curTerminationTime) > new Date(gigTerminationTime) ? curTerminationTime : gigTerminationTime })

}